<script>
export default {
    name: 'RestaurantBanner',
    props: {
        restaurant: {
            type: Object,
            default: () => {},
        },
    },
}
</script>

<template lang="pug">
.alert.alert-info.mb-0
    icon.mr-2.icon-baseline(icon="fa-solid fa-info-circle")
    | {{restaurant.banner}}


</template>
